import React, { Fragment, useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from 'reactstrap';
import { LockerViewV1 } from '@components/common/Seat';
import { AddBtn, Button, Label1 } from '@components/common/StyledComponents';
import { TabButton } from '@components/common/TabNavigation';
import ToggleContainer from '@components/common/ToggleContainer';
import { ToggleBtn } from '@components/common/ToggleSwitch';
import Breadcrumb from '@layout/breadcrumb';
import {
  deleteSeat,
  getLockerList,
  getMerchantInfo,
  postCreateSeat,
} from '@lib/api';
import useHandleAPICall from '@lib/hooks/useHandleAPICall';
import useHandleError from '@lib/hooks/useHandleError';
import useAppStore from '@store/useAppStore';
import theme from '@theme/index';
import { asArray, firstArray } from '@util/array';
import { isLockerPurchaseLocked } from '@util/lockerLock';
import styled from 'styled-components';
import Swal from 'sweetalert2';

// Re-export shared styled components
export { AddBtn, Button, Label1 };

const CardContainer = styled.div`
  .cardBody {
    display: flex;
  }
  .date-pickers {
    display: flex;
  }
  .topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .m-0 {
      display: flex;
      align-items: center;
      position: relative;
      width: 100%;
      i {
        position: absolute;
        top: 0.8vw;
        right: 0.5vw;
      }
      input {
        width: 100%;
      }
    }
  }
  .floorBtn {
    display: 'flex';
    flex-direction: 'column';
  }
  @media screen and (max-width: 768px) {
    .floorBtn {
      flex-direction: row;
    }
  }
  @media screen and (max-width: 480px) {
    .topbar {
      align-items: baseline;
      flex-direction: column;
      .m-0 {
        margin: 3vw 0 !important;
      }
    }
    button {
      margin: 1vw 0 5vw;
    }
    input {
      width: 80% !important;
    }
    .cardBody {
      flex-direction: column;
    }
  }
`;

export const LockerView = styled.div`
  width: 981px;
  width: 100%;
  height: 60vh;
  border: 3px solid #222;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 0.6vw;
    height: 0.6vw;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #c4cbd6;
    border-radius: 1vw;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 1vw;
  }
`;
export const LockersArray = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(20, 1fr);
  @media screen and (max-width: 480px) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

export const LockerS = styled.div`
  width: 71px;
  height: 71px;
  background-color: ${(props) => (props.isUse ? '#888EA5' : '#fff')};
  border: 1px solid #546382;
  color: ${(props) => (props.isUse ? '#ccc' : '#222')};
  display: flex;
  flex-direction: column;
  /* justify-content: center;
  align-items: center; */
  font-size: 2.3vw;
  font-weight: 600;
  top: ${(props) => `${props.top}vw`};
  left: ${(props) => `${props.left}vw`};
  padding: 5px;

  p {
    margin-bottom: 0;
    /* text-align: center; */
    font-size: 11px;
    line-height: 1.2;
  }
`;

const Btns = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 12%;
  margin-left: 0.6vw;

  > button {
    background-color: ${({ theme }) => theme.primary};

    :last-child {
      background-color: #f53c14;
      margin-top: 0.6vw;
    }
  }
  @media screen and (max-width: 768px) {
    width: 20%;
  }
  @media screen and (max-width: 480px) {
    flex-direction: row;
    width: 100%;
    margin-left: 0vw;
    > button {
      :last-child {
        margin-top: 1vw;
      }
    }
  }
`;

const LockerChange = ({ setIsLoading }) => {
  const { createRequest } = useHandleAPICall();
  const { catchError } = useHandleError();
  const { merchantData } = useAppStore();
  const merchantId = merchantData?.id;

  const [lists, setLists] = useState([]);
  const [tagModal, setTagModal] = useState(false);
  const [selected, setSelected] = useState();
  const [changeData, setChangeData] = useState([]);
  const [multiNum, setMultiNum] = useState(null);
  const [floorNum, setFloorNum] = useState(0);
  const [floorList, setFloorList] = useState([]);

  const getLockerListApi = async (merchantId, floorData) => {
    try {
      const res = await createRequest(getLockerList, merchantId);
      const lockers = asArray(res?.data);
      setLists(lockers);

      if (floorData) {
        setFloorList(lockers.filter((item) => item.floor === floorData));
      }
    } catch (error) {
      catchError(error);
    }
  };

  const initMerchantData = async () => {
    if (!merchantId) return;
    try {
      const multiNumData = await createRequest(getMerchantInfo, merchantId);
      const merchant = firstArray(multiNumData?.data)[0];
      if (multiNumData && multiNumData.status === 200 && merchant?.multiKioskFloor > 0) {
        setMultiNum(merchant.multiKioskFloor);
        setFloorNum(1);
        getLockerListApi(merchantId, 1);
      } else {
        getLockerListApi(merchantId, null);
      }
    } catch (error) {
      catchError(error);
    }
  };
  useEffect(() => {
    initMerchantData();
  }, [merchantId]);

  const handleLockerOnClick = (locker) => {
    tagToggle();
    setSelected(locker);
  };
  const tagToggle = () => {
    setTagModal(!tagModal);
  };
  const handleError = (msg) => {
    Swal.fire({
      icon: 'error',
      timer: 2000,
      title: '현재 사용중인 사물함은 변경이 불가능합니다.',
    });
  };
  const handleAddLocker = () => {
    const fakeId = new Date().getTime();

    const newObj = {
      fakeId,
      number: lists.length + 1,
      name: '',
      status: 'idle',
      type: 'locker',
      level: 1,
      pos_top: 0,
      pos_left: 0,
      id: 0,
      floor: floorNum,
      seatType: 0,
    };
    setFloorList([...floorList, newObj]);
    setLists([...lists, newObj]);
    setChangeData([...changeData, newObj]);
  };

  const handleOnchange = ({ target }) => {
    if (target.name === 'number') {
      setSelected({ ...selected, [target.name]: +target.value });
    } else if (target.name === 'status') {
      if (target.value === 'idle') {
        setSelected({ ...selected, status: 'block' });
      } else {
        setSelected({ ...selected, status: 'idle' });
      }
    } else if (target.name === 'floor') {
      setSelected({ ...selected, floor: +target.value });
    } else {
      setSelected({ ...selected, [target.name]: target.value });
    }
  };

  const lockerInfoChange = () => {
    let copyData = [...lists];

    let filterChangeData = copyData.map((item) =>
      item.id === selected.id && item?.fakeId === selected?.fakeId ? selected : item,
    );
    if (floorNum) {
      let floorData = floorList
        .map((item) =>
          item.id === selected.id && item?.fakeId === selected?.fakeId ? selected : item,
        )
        .filter((item) => item.floor === floorNum);
      setFloorList(floorData);
    }
    setLists(filterChangeData);

    if (!changeData.map((li) => li.id).includes(selected.id)) {
      setChangeData((pre) => pre.concat(selected));
    } else {
      setChangeData((pre) =>
        pre.map((li) =>
          li.id === selected.id && li?.fakeId === selected?.fakeId
            ? {
                ...li,
                fakeId: selected?.fakeId,
                number: selected.number,
                name: selected.name,
                status: selected.status,
                level: selected.level,
                seatType: selected.seatType,
                floor: selected.floor,
              }
            : { ...li },
        ),
      );
    }
    tagToggle();
    setSelected();
  };

  const seatChangeCancel = () => {
    tagToggle();
    setSelected();
  };

  const seatDelete = () => {
    if (selected.id === 0) {
      const copyData = [...lists];
      const copyChangeData = [...changeData];
      const copyFloorData = [...floorList];
      const changeList = copyData.filter((item) => item?.fakeId !== selected?.fakeId);
      const changeList1 = copyChangeData.filter((item) => item?.fakeId !== selected?.fakeId);
      const changeList2 = copyFloorData.filter((item) => item?.fakeId !== selected?.fakeId);
      setLists(changeList);
      setChangeData(changeList1);
      setFloorList(changeList2);
      tagToggle();
      setSelected();
    } else {
      Swal.fire({
        icon: 'warning',
        title: '삭제 시 저장하지 않은 데이터는 사라집니다.',
        text: '그래도 지우시겠습니까?',
        confirmButtonColor: '#F53C14',
        cancelButtonColor: '#04c9db',
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then(async (result) => {
        if (!result.isConfirmed) return;
        try {
          await createRequest(deleteSeat, selected.id, selected.merchantId);
          Swal.fire({
            icon: 'success',
            title: '삭제가 완료되었습니다.',
            timer: 2000,
          }).then(() => {
            window.location.reload();
            tagToggle();
          });
        } catch (error) {
          catchError(error);
        }
      });
    }
  };

  const handleOnSubmit = async () => {
    try {
      const copyData = [...changeData];
      const filterArr = copyData.map((item) =>
        item.fakeId
          ? {
              number: item.number,
              name: item.name,
              status: item.status,
              type: 'locker',
              level: item.level,
              pos_top: item.pos_top,
              pos_left: item.pos_left,
              id: item.id,
              seatType: item.seatType,
              floor: item.floor,
            }
          : item,
      );
      const res = await createRequest(postCreateSeat, { seat: filterArr, merchantId });
      if (res.status === 200) {
        Swal.fire({
          icon: 'success',
          title: '변경이 완료됐습니다.',
          timer: 3000,
        }).then(() => window.location.reload());
      } else {
        Swal.fire({
          icon: 'error',
          title: '변경에 실패했습니다. 다시 시도해주세요.',
          timer: 2000,
        });
      }
    } catch (error) {
      catchError(error);
    }
  };
  const handleReset = () => {
    Swal.fire({
      title: '저장하지 않은 데이터는 사라집니다.',
      text: '변경을 취소하시겠습니까?',
      showCancelButton: true,
      confirmButtonColor: '#F53C14',
      cancelButtonColor: '#04c9db',
      confirmButtonText: '예',
      cancelButtonText: '아니오',
    }).then(() => window.location.reload());
  };

  useEffect(() => {
    if (merchantId && floorNum > 0) getLockerListApi(merchantId, floorNum);
  }, [floorNum, merchantId]);

  return (
    <Fragment>
      {tagModal && (
        <Modal centered isOpen={tagModal} toggle={tagToggle}>
          <ModalHeader className="modal-title" toggle={tagToggle}>
            사물함 정보 수정
          </ModalHeader>
          <ModalBody>
            <Label1>
              사물함 번호
              <input
                type="text"
                name="number"
                value={selected.number || 0}
                onChange={handleOnchange}
                placeholder="사물함 번호를 입력해주세요."
              />
            </Label1>
            <Label1>
              사물함 이름
              <input
                type="text"
                name="name"
                value={selected.name || ''}
                onChange={handleOnchange}
                placeholder="사물함 이름을 입력해주세요."
              />
            </Label1>
            {floorNum && (
              <Label1>
                층 설정
                <Input
                  type="text"
                  name="floor"
                  value={selected?.floor || ''}
                  onChange={handleOnchange}
                />
              </Label1>
            )}
            <ToggleContainer>
              사물함 사용불가 설정
              <ToggleBtn>
                <input
                  type="checkbox"
                  name="status"
                  onChange={handleOnchange}
                  value={selected.status || ''}
                  checked={selected.status === 1 || selected?.status === 'block'}
                />
                <span className="onoff-switch"></span>
              </ToggleBtn>
            </ToggleContainer>
            <div
              style={{
                display: 'flex',
                width: '100%',
                gap: '10px',
              }}>
              <Button color="#fff" onClick={seatChangeCancel}>
                취소
              </Button>
              <Button color={theme.primary} onClick={lockerInfoChange}>
                확인
              </Button>
              <Button color="#F53C14" onClick={seatDelete}>
                삭제
              </Button>
            </div>
          </ModalBody>
        </Modal>
      )}
      <Breadcrumb parent="좌석 및 사물함" title="사물함 배치 변경" />
      <Container fluid={true}>
        <CardContainer>
          <Row>
            <Col sm="12" style={{ paddingLeft: '5px', paddingRight: '5px' }}>
              <Card>
                <CardBody className="cardBody">
                  <div>
                    <AddBtn
                      style={{
                        width: window.innerWidth > 480 ? '80%' : '100%',
                      }}
                      onClick={handleAddLocker}>
                      사물함 추가
                    </AddBtn>
                    {multiNum && (
                      <div className="floorBtn">
                        {[...Array(multiNum)].map((item, index) => (
                          <TabButton
                            selected={floorNum === index + 1}
                            onClick={() => setFloorNum(index + 1)}
                            value={index + 1}>
                            {index + 1}층
                          </TabButton>
                        ))}
                      </div>
                    )}
                  </div>
                  <LockerViewV1>
                    <LockersArray>
                      {(floorNum > 0 ? floorList : lists)?.map((seat, index) => {
                        const purchaseLocked = isLockerPurchaseLocked(seat.lockedUntil);
                        return (
                        <React.Fragment key={seat.id === 0 ? seat?.fakeId : seat.id}>
                          {(seat.status === 'block' || seat.status === 1 || purchaseLocked) && (
                            <LockerS
                              style={{
                                width: 69,
                                height: 69,
                                backgroundColor: '#979797',
                              }}
                              onClick={() => handleLockerOnClick(seat)}
                              isUse>
                              <p>
                                {seat.number}.{purchaseLocked ? '구매잠금' : seat.name}
                              </p>
                            </LockerS>
                          )}
                          {seat.status === 'idle' && !purchaseLocked && (
                            <LockerS
                              style={{ width: 69, height: 69 }}
                              onClick={() => handleLockerOnClick(seat)}>
                              <p>
                                {seat.number}.{seat.name}
                              </p>
                            </LockerS>
                          )}
                          {seat.status === 'using' && (
                            <LockerS style={{ width: 69, height: 69 }} onClick={handleError} isUse>
                              <p>
                                {seat.number}.{seat.name}
                              </p>
                            </LockerS>
                          )}
                        </React.Fragment>
                        );
                      })}
                    </LockersArray>
                  </LockerViewV1>
                  <Btns>
                    <Button onClick={handleOnSubmit}>변경하기</Button>
                    <Button onClick={handleReset}>취소하기</Button>
                  </Btns>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </CardContainer>
      </Container>
    </Fragment>
  );
};

export default LockerChange;
